export function FormService() {
  const errorMessageMapping = [
    { validityState: 'valueMissing', inputMessageAttribute: 'data-required-error' },
    { validityState: 'customError', inputMessageAttribute: 'data-custom-error' },
    { validityState: 'patternMismatch', inputMessageAttribute: 'data-pattern-error' },
    { validityState: 'rangeOverflow', inputMessageAttribute: 'data-max-error' },
    { validityState: 'rangeUnderflow', inputMessageAttribute: 'data-min-error' },
    { validityState: 'stepMismatch', inputMessageAttribute: 'data-step-error' },
    { validityState: 'tooLong', inputMessageAttribute: 'data-maxlength-error' },
    { validityState: 'tooShort', inputMessageAttribute: 'data-minlength-error' },
    { validityState: 'typeMismatch', inputMessageAttribute: 'data-type-error' },
  ];

  /**
   * Callback for the validation event listeners for a form field.
   *
   * @param {Event} event the event that triggered the validation
   */
  function validateInput(event) {
    checkFieldValidityAndDisplayOrRemoveErrors(event.target);
  }

  /**
   * Checks validity of a form field, and toggles the validation message accordingly.
   *
   * @param {Element} input the input field
   */
  function checkFieldValidityAndDisplayOrRemoveErrors(input) {
    const fieldset = input.closest('fieldset');
    const inputs = fieldset.querySelectorAll('input, textarea');
    const errorOutput = fieldset.querySelector('output');
    const labels = fieldset.querySelectorAll('label, legend');

    if (input.checkValidity()) {
      if (errorOutput) {
        errorOutput.textContent = '';
      }

      inputs.forEach((input) => input.classList.remove('is-invalid-input'));
      labels.forEach((label) => label.classList.remove('is-invalid-label'));

      return;
    }

    if (errorOutput) {
      errorOutput.textContent = getValidationMessage(input);
    }

    inputs.forEach((input) => input.classList.add('is-invalid-input'));
    labels.forEach((label) => label.classList.add('is-invalid-label'));
  }

  /**
   * Returns a custom or default validation message for a form field.
   *
   * @param {Element} input the input field
   */
  function getValidationMessage(input) {
    const validationState = errorMessageMapping.find(
      (validationStateObject) => input.validity[validationStateObject.validityState]
    );

    return input.getAttribute(validationState.inputMessageAttribute) ?? input.validationMessage;
  }

  return {
    /**
     * Adds validators to all of the input/textarea elements within a form.
     *
     * @param {string} formSelector the selector for the form
     * @param {array}  triggerEvents the events to trigger the validation
     */
    setValidators: (formSelector, triggerEvents = ['input', 'blur']) => {
      const inputs = document.querySelectorAll(`${formSelector} input, ${formSelector} textarea`);

      triggerEvents.forEach((triggerEvent) => {
        inputs.forEach((input) => {
          input.addEventListener(triggerEvent, validateInput);
        });
      });
    },

    /**
     * Runs the validation checks for all of the inputs/textareas within a form.
     *
     * @param {string} formSelector the selector for the form
     */
    validateAllInputs: (formSelector) => {
      const inputs = document.querySelectorAll(`${formSelector} input, ${formSelector} textarea`);

      inputs.forEach((input) => {
        checkFieldValidityAndDisplayOrRemoveErrors(input);
      });
    },
  };
}
